import { makeStyles, Snackbar, TextField, Typography, Button, Card, CardHeader, CardContent } from '@material-ui/core'
import React, { useState } from 'react'
import Layout from '../components/layout/Layout'
import { useFormik } from "formik"
import api from '../api/client';
import { useRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'
import { userInfoState } from '../recoil/atoms'
import MuiAlert from '@material-ui/lab/Alert';
import { toEnglishDigits } from '../assets/utils'

const useStyles = makeStyles(theme => ({
    root: {
        marginLeft: '25%',
        marginRight: '25%',
        direction: 'rtl'
    },
}))

const EditProfile = () => {
    const [userInfo, setUserInfo] = useRecoilState(userInfoState)
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const classes = useStyles()
    const navigate = useNavigate()
    const formik = useFormik({
        initialValues: {
            mobile: userInfo.mobile || '',
            password1: '',
            password2: '',
        },
        onSubmit: async values => {
            if (values.password1 !== values.password2) {
                setError(true)
                setErrorMessage('کلمه عبور و تکرار آن مطابقت ندارند.')
                return
            }
            const mobileDigits = toEnglishDigits(String(values.mobile || '').trim()).replace(/\s+/g, '')
            const mobile10 = /^9\d{9}$/.test(mobileDigits) ? '0' + mobileDigits : mobileDigits
            if (!/^09\d{9}$/.test(mobile10)) {
                setError(true)
                setErrorMessage('شمارهٔ همراه باید ۱۱ رقم و با ۰۹ آغاز شود (مثلاً ۰۹۱۲۱۲۳۴۵۶۷).')
                return
            }
            const result = await api.put('users/change/', {
                mobile: mobile10,
                password: toEnglishDigits(values.password1) !== '' ? toEnglishDigits(values.password1) : null
            })
            if (result.status === 201) {
                setUserInfo((prev) => ({ ...(prev || {}), ...(result.data || {}) }))
                setSuccess(true)
                // اگر کاربر به‌خاطرِ اجبارِ موبایل/رمز اینجا آمده بود ⇒ بعد از
                // ثبتِ موفق، به داشبورد برگردد
                setTimeout(() => {
                    try { navigate('/', { replace: true }) } catch (e) { /* noop */ }
                }, 1200)
            } else {
                setError(true)
                setErrorMessage('خطا در اعمال تغییرات')
            }
        },
    })

    return (
        <>
            <Layout>
                <Card style={{ background: '#f1f1f1', }} elevation={5}>
                    <CardHeader
                        title='ویرایش مشخصات'
                        action={
                            <Button
                                size='small'
                                variant='outlined'
                                style={{ marginTop: 8 }}
                                onClick={() => {
                                    localStorage.removeItem('tour_done_' + (userInfo.role || ''))
                                    sessionStorage.setItem('tour_active', '1')
                                    sessionStorage.setItem('tour_step', '0')
                                    window.location.href = '/'
                                }}
                            >
                                🎓 اجرای دوبارهٔ تور آموزشی
                            </Button>
                        }
                    />
                    <CardContent>
                        {userInfo.first_time_login && (
                            <Typography variant='h6' style={{ color: 'red', textAlign: 'center' }}>
                                برای استفاده از سامانه لطفاً رمز عبور خود را تغییر دهید.
                            </Typography>
                        )}
                        {!userInfo.mobile && (
                            <Typography variant='h6' style={{ color: '#e65100', textAlign: 'center' }}>
                                ثبتِ شمارهٔ تلفن همراه برای هر کاربر اجباری است؛ لطفاً شمارهٔ خود را وارد کنید.
                            </Typography>
                        )}
                        <form className={classes.root} onSubmit={formik.handleSubmit}>
                            <TextField
                                margin='normal'
                                id="mobile"
                                label="شماره تلفن همراه"
                                required
                                variant='outlined'
                                fullWidth
                                onChange={formik.handleChange}
                                value={formik.values.mobile}
                            />
                            <TextField
                                margin='normal'
                                id="password1"
                                label="کلمه عبور"
                                required={userInfo.first_time_login}
                                variant='outlined'
                                fullWidth
                                type='password'
                                onChange={formik.handleChange}
                                value={formik.values.password1}
                            />
                            <TextField
                                margin='normal'
                                id="password2"
                                label="تکرار کلمه عبور"
                                required={userInfo.first_time_login}
                                variant='outlined'
                                fullWidth
                                type='password'
                                onChange={formik.handleChange}
                                value={formik.values.password2}
                            />
                            <Button
                                variant='contained'
                                color='primary'
                                fullWidth
                                type='submit'
                                className={classes.button}
                                disabled={formik.isSubmitting}
                            >
                                <Typography>
                                    ویرایش
                        </Typography>
                            </Button>
                        </form>
                    </CardContent>
                </Card>
            </Layout >
            <Snackbar Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                <MuiAlert elevation={6} onClose={() => setError(false)} variant='filled' severity="error">
                    <Typography>
                        {errorMessage}
                    </Typography>
                </MuiAlert>
            </Snackbar>
            <Snackbar Snackbar open={success} autoHideDuration={6000} onClose={() => setSuccess(false)}>
                <MuiAlert elevation={6} onClose={() => setSuccess(false)} variant='filled' severity="success">
                    <Typography>
                        تغییرات با موفقیت اعمال شد.
                    </Typography>
                </MuiAlert>
            </Snackbar>
        </>

    )
}

export default EditProfile